<aside class="main-layout__sidebar" aria-label="Project navigation">
  <div class="main-layout__sidebar-header">
    <p class="main-layout__sidebar-title">
      {{ 'sidebar.open-collaboration-platform' | translate }}
    </p>
    <span class="main-layout__sidebar-badge">{{ 'sidebar.early-access' | translate }}</span>
  </div>
  <ng-content />
</aside>
